require('map-tools/dist/scripts/nrelmt-no-libs');
require('coalitions/locations-map');

(function() {

  var $self = this;
  $self.Coalitions           = $self.Coalitions           || {};
  $self.Coalitions.locations = $self.Coalitions.locations || {};

  $self.Coalitions.locations.init = function() {
    $self.Coalitions.locations.map.init();
  };

}).call(CC);
